import { L10n } from '../L10n/L10n';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Schedules } from '../resources/Schedules';
import { ISchedule } from '../../schedule/types/ISchedule';
import { AbstractContentAction } from './AbstractContentAction';
import { ConfirmActionDialog, IConfirmActionDialogOptions } from './ConfirmActionDialog';
import { ContentActionNotification, INotificationTranslationIds } from './ContentActionNotification';

export class RunSchedulesAction extends AbstractContentAction<ISchedule> {

  public static $inject = ['ConfirmActionDialog', 'ContentActionNotification', '$translate', 'Schedules'];

  constructor(
            ConfirmActionDialog: ConfirmActionDialog,
            ContentActionNotification: ContentActionNotification,
    private $translate: ng.translate.ITranslateService,
    private Schedules: Schedules
  ) {
    super(ConfirmActionDialog, ContentActionNotification);
  }

  configureDialog(dialogConfig: IConfirmActionDialogOptions, schedules: Set<ISchedule>) {
    dialogConfig.bodyText = this.$translate.instant('schedulesRunPrompt', {
      ITEM_COUNT: schedules.size(),
      ITEM_NAME: L10n.elideIfLong(schedules.first().name)
    }, L10n.Interpolations.Count);
    dialogConfig.title = this.$translate.instant('runNow');
    dialogConfig.actionName = this.$translate.instant('runNowConfirmButton');
    dialogConfig.action = () => this.Schedules.run(schedules.keys());
  }

  notificationTranslationIds(): INotificationTranslationIds {
    return {
      successId: 'schedulesRunSuccess',
      errorId: 'schedulesRunError'
    };
  }

}

Module.instance().service('RunSchedulesAction', RunSchedulesAction);
